import { useTranslation } from 'react-i18next'
import ApiVersion from './_api-version'

interface AppFooterProps {
  brand?: string
}

export const AppFooter = ({ brand }: AppFooterProps) => {
  const { t } = useTranslation('common')
  return (
    <footer className="footer">
      <p>
        {brand ?? t('footer.brand')} - <ApiVersion />
      </p>
    </footer>
  )
}
